// @ts-check
import { enums } from '@bluecrew/bluecrew-lib'
import { Category } from '../constants'
import moment from 'moment-timezone'

export class excusedAllAbsentModalController {
    /* @ngInject */
    constructor (roster, date, $mdDialog, PayrollService, $mdToast) {
        this.PayrollService = PayrollService
        this.$mdToast = $mdToast
        this.roster = roster
        this.$mdDialog = $mdDialog
        this.enums = enums
        this.reason = undefined
        this.formattedDate = moment(date).format('dddd, MMMM D YYYY')

        this.statusChangeReasons = [
            { value: 15, description: 'Holiday' },
            { value: 16, description: 'Workplace closure' },
            { value: 19, description: 'Other' }
        ]
    }

    cancel () {
        this.$mdDialog.cancel()
    }

    /**
     * 
     * @param {number} reason users_hours.reason
     */
    submitAbsence (reason) {
        const comments = undefined

        let newStatus = this.enums.PayrollHoursStatus.DAY_OFF
        if (this.roster.shifts.length > 0) {
            this.roster.shifts.forEach(shift => {
                let job = this.roster.jobs.find(j => j.id === shift.job_id);
                this.PayrollService
                    .updateHoursStatus(newStatus, shift.external_id, job.external_id, shift.shift, reason, comments)
                    .catch(err => {
                        this.$mdToast.showSimple(err)
                    })
            });
        }
        this.$mdDialog.hide({roster: this.roster, category: Category.MarkedAbsent, usersHoursReasonCode: reason})
        location.reload();
    }
}
